import React from 'react';
import PropTypes from 'prop-types';

import { useFormatMessage } from '../../../intl/intlHooks';
import { useSettings } from '../../../mall_settings/SettingsProvider';

import { ToggleField } from '../../core';
import { agreeToTermsFieldMessages } from './formFieldMessages';

export const TERMS_AGREEMENT = 'termsAgreement';
export const AgreeToTermsField = ({clickHandler}) => {
    const { privacyPolicyUrl, termsOfUseUrl } = useSettings();
    const formatMessage = useFormatMessage();
    
    const label = termsOfUseUrl && privacyPolicyUrl ? formatMessage(agreeToTermsFieldMessages.policyAndAgreementLinks, {
        terms: str => <a key="terms-of-use" href={termsOfUseUrl} className="terms-of-use" target="_blank" rel="noopener noreferrer">{str}</a>,
        policy: str => <a key="privacy-policy" href={privacyPolicyUrl} className="privacy-policy" target="_blank" rel="noopener noreferrer">{str}</a>,
    }) : 'I agree to terms of service and privacy policy';
    return (
        <ToggleField
            name={TERMS_AGREEMENT}
            toggleClickHandler={clickHandler}
            label={label}
        />
    );
};

AgreeToTermsField.propTypes = {
    clickHandler: PropTypes.func.isRequired
};
